import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=cf708506&scoped=true&"
import script from "./DocumentTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=cf708506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf708506",
  null
  
)

export default component.exports